import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const MaintenanceChecker = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isInMaintenance, setIsInMaintenance] = useState(false);
    const [maintenanceMessage, setMaintenanceMessage] = useState('');

    useEffect(() => {
        const checkMaintenance = async () => {
            try {
                const res = await fetch(`${API_URL}/app_configs?cle=maintenance`, {
                    credentials: 'include',
                    headers: { 'Accept': 'application/ld+json' }
                });
                if (!res.ok) throw new Error('API indisponible');
                const json = await res.json();
                const members = json['hydra:member'] || json.member || [];
                if (members.length > 0) {
                    const config = members[0];
                    const data = JSON.parse(config.valeur || '{}');
                    // Mise à jour du cache local
                    localStorage.setItem('maintenancePages', config.valeur);
                    const pages = data.pages || [];
                    const currentPath = location.pathname;
                    const inMaintenance = pages.some(p => currentPath === p || currentPath.startsWith(p + '/'));
                    setIsInMaintenance(inMaintenance);
                    setMaintenanceMessage(data.message || 'Cette page est temporairement indisponible pour maintenance.');
                    return;
                }
            } catch {
                // Fallback sur le cache local si l'API est inaccessible
                const saved = localStorage.getItem('maintenancePages');
                if (saved) {
                    try {
                        const data = JSON.parse(saved);
                        const pages = data.pages || [];
                        const currentPath = location.pathname;
                        const inMaintenance = pages.some(p => currentPath === p || currentPath.startsWith(p + '/'));
                        setIsInMaintenance(inMaintenance);
                        setMaintenanceMessage(data.message || 'Cette page est temporairement indisponible pour maintenance.');
                        return;
                    } catch {}
                }
            }
            setIsInMaintenance(false);
        };

        checkMaintenance();
    }, [location.pathname]);

    if (isInMaintenance) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
                padding: '20px'
            }}>
                <div style={{
                    background: '#fff',
                    borderRadius: '16px',
                    padding: '48px 32px',
                    maxWidth: '600px',
                    width: '100%',
                    textAlign: 'center',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
                }}>
                    <div style={{ fontSize: '80px', marginBottom: '24px', animation: 'bounce 2s infinite' }}>
                        
                    </div>

                    <h1 style={{
                        margin: '0 0 16px 0',
                        fontSize: '32px',
                        fontWeight: 700,
                        color: '#991b1b',
                        lineHeight: 1.2
                    }}>
                        Page en maintenance
                    </h1>

                    <p style={{
                        margin: '0 0 32px 0',
                        fontSize: '16px',
                        color: '#7f1d1d',
                        lineHeight: 1.6
                    }}>
                        {maintenanceMessage}
                    </p>

                    <button
                        onClick={() => navigate('/')}
                        style={{
                            padding: '14px 32px',
                            borderRadius: '8px',
                            border: 'none',
                            background: '#ef4444',
                            color: '#fff',
                            fontSize: '16px',
                            fontWeight: 600,
                            cursor: 'pointer',
                            transition: 'all 0.2s',
                            boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = '#dc2626';
                            e.target.style.transform = 'translateY(-2px)';
                            e.target.style.boxShadow = '0 6px 16px rgba(239, 68, 68, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = '#ef4444';
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.3)';
                        }}
                    >
                         Retour au tableau de bord
                    </button>
                </div>

                <style>{`
                    @keyframes bounce {
                        0%, 100% { transform: translateY(0); }
                        50% { transform: translateY(-20px); }
                    }
                `}</style>
            </div>
        );
    }

    return children;
};

export default MaintenanceChecker;
